import { rm } from "node:fs/promises";
import { join } from "node:path";
import { daemonRuntimeLeaseSchema } from "@wakeloop/schemas";
import type { DaemonRuntimeLease } from "@wakeloop/schemas/types";
import {
  readDaemonLocalStateFile,
  writeDaemonLocalStateFile,
} from "./daemon-local-state-file";
import { daemonRuntimeStateRootPath } from "./daemon-state";
import type { WakeLoopPathResolutionInput } from "./paths";

const DAEMON_RUNTIME_LEASE_FILENAME = "runtime-lease.json";

export function daemonRuntimeLeasePath(
  pathInput: WakeLoopPathResolutionInput = {}
): string {
  return join(
    daemonRuntimeStateRootPath(pathInput),
    DAEMON_RUNTIME_LEASE_FILENAME
  );
}

export async function readDaemonRuntimeLease(
  pathInput: WakeLoopPathResolutionInput = {}
): Promise<DaemonRuntimeLease | null> {
  return await readDaemonLocalStateFile({
    path: daemonRuntimeLeasePath(pathInput),
    schema: daemonRuntimeLeaseSchema,
  });
}

export async function writeDaemonRuntimeLease(
  lease: DaemonRuntimeLease,
  pathInput: WakeLoopPathResolutionInput = {}
): Promise<void> {
  await writeDaemonLocalStateFile({
    path: daemonRuntimeLeasePath(pathInput),
    schema: daemonRuntimeLeaseSchema,
    value: lease,
    mode: 0o600,
  });
}

export async function clearDaemonRuntimeLease(
  pathInput: WakeLoopPathResolutionInput = {}
): Promise<void> {
  await rm(daemonRuntimeLeasePath(pathInput), { force: true });
}
